(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const burger = document.querySelector('.mobile-nav-icon-burger');
  const mobileNavMenu = document.querySelector('#mobile-nav-menu');
  const closeIcon = document.querySelector('.mobile-nav-icon-close');

  burger.addEventListener('click', function() {
    var cartItemCntMobile = document.querySelector('#cart-icon-bubble-mobile .cart-count-bubble');
    var cartItemCntDesktop = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    
    if(cartItemCntDesktop) {
      cartItemCntMobile.classList.remove('no-item');
      cartItemCntMobile.innerHTML = cartItemCntDesktop.innerHTML;
    }

    mobileNavMenu.classList.toggle('open');
  });

  closeIcon.addEventListener('click', function() {
    mobileNavMenu.classList.toggle('open');
    });

    const resourcesMenu = document.querySelector('.mobile-resources-menu');
    const resourcesNav = document.querySelector('.nav-mobile-resources');
    const resourcesCloseIcon = document.querySelector('.mobile-nav-icon-close.resources');

    resourcesMenu.addEventListener('click', function(e) {
    e.stopPropagation();
    resourcesNav.classList.toggle('open');
    });

    resourcesCloseIcon.addEventListener('click', function() {
    resourcesNav.classList.toggle('open');
    });

    const aboutMenu = document.querySelector('.mobile-about-menu');
const aboutNav = document.querySelector('.nav-mobile-about');
const aboutCloseIcon = document.querySelector('.mobile-nav-icon-close.about');

aboutMenu.addEventListener('click', function(e) {
  e.stopPropagation();
  aboutNav.classList.toggle('open');

  
});

aboutCloseIcon.addEventListener('click', function() {
  aboutNav.classList.toggle('open');
});

const inlineMenuItems = document.querySelectorAll('.header__inline-menu > ul > li');

inlineMenuItems.forEach(item => {
  item.addEventListener('mouseover', function() {
    const details = item.querySelector('details');
    if (details) {
      details.setAttribute('open', '');
    }
  });

  item.addEventListener('mouseout', function() {
    const details = item.querySelector('details');
    if (details) {
      details.removeAttribute('open');
    }
  });
});

  const inlineChildMenuItems = document.querySelectorAll('.header__submenu > li');

inlineChildMenuItems.forEach(item => {
  item.addEventListener('mouseover', function() {
    const details = item.querySelector('details');
    if (details) {
      details.setAttribute('open', '');
    }
  });

  item.addEventListener('mouseout', function() {
    const details = item.querySelector('details');
    if (details) {
      details.removeAttribute('open');
    }
  });
});

  const mobileChildMenuItems = document.querySelectorAll('#mobile-nav-menu .menu-drawer__menu.has-submenu summary');
  const allMobileMenuItems = document.querySelectorAll('#mobile-nav-menu .menu-drawer__menu.has-submenu details');
  
  mobileChildMenuItems.forEach(item => {
    item.addEventListener('click', function(e) {
      const parentNode = item.parentNode;

      if(!parentNode.hasAttribute('open')) { 
         allMobileMenuItems.forEach(item1 => { 
            item1.removeAttribute('open');
          })
         item.setAttribute('open',''); 
      }
    })
  })


  } catch(e) { console.error(e); }
})();
})();
